<template>
	<nk-wrapper v-if="context.lebenslage" spacing="lg">
		<section>
			<nk-title tag="h1" size="2xl">
				{{ lebenslage.name }}
			</nk-title>

			<template v-if="lebenslage.leistungen.length">
				<nk-title tag="h2" size="xl">Leistungen</nk-title>

				<nk-nav aria-label="Leistungen Links">
					<nk-nav-item
						v-for="(leistung, leistungIndex) in lebenslage.leistungen"
						:key="leistungIndex"
						:link="`${
							context.taggingpfadLeistungen.slice(-1) !== '/'
								? context.taggingpfadLeistungen + '/'
								: context.taggingpfadLeistungen
						}${leistung.id}`"
					>
						{{ leistung.name }}
					</nk-nav-item>
				</nk-nav>
			</template>

			<!-- Textblock Preamble -->
			<div v-html="preambleText" />

			<!-- Textbloecke -->
			<div
				v-for="(textblock, textbloeckeIndex) in lebenslage.textbloecke"
				:key="textbloeckeIndex"
			>
				<template v-if="textblock.text && textblock.typ !== 'preamble'">
					<nk-title tag="h2" size="xl">
						{{ textblock.titel }}
					</nk-title>
					<div v-html="textblock.text" />
				</template>
			</div>
		</section>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import {updateBreadcrumb} from '#nk/composables/cms';

/**
 * @prop {object} context.lebenslage
 * @prop {object} context.taggingpfadLeistungen
 */
export default {
	name: 'NkTemplateServiceBwLeistungsDetails',

	mixins: [TemplatesDefault],

	setup(ctx) {
		updateBreadcrumb({title: ctx.context.organisationseinheit.name});
	},

	computed: {
		preambleText() {
			const {text} = this.context.lebenslage.textbloecke.find(
				textblock => textblock.typ === 'preamble',
			);
			return text;
		},
	},
};
</script>
